var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGiftCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 22,
    y1: 70,
    x2: 22,
    y2: 99.4,
    gradientTransform: "translate(0 -70)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ff402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22d43e"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "oooAsset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.6,10.5A10.5,10.5,0,0,1,24.1,21H17.8a8.45,8.45,0,0,1-8.4,8.4h0V16.8a4.16,4.16,0,0,1,4.2-4.2H24.1a2,2,0,0,0,2.1-2.1,2.18,2.18,0,0,0-2.1-2.1H9.4V0H24.1A10.5,10.5,0,0,1,34.6,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,42V35.7H4.1c1.6,0,2.5.8,2.5,2.2s-1,2.2-2.5,2.2H1.5V42Zm1.5-5v1.9H4.1c.7,0,1-.3,1-.9s-.3-.9-1-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.1,40.8H12.5L11.8,42H10.2l3.4-6.3h1.2L18.2,42H16.6Zm-2.9-1.3h2.2l-1.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.1,35.7H25l3.5,4.6V35.7H30V42H28.1l-3.5-4.6V42H23.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.8,40.8H36.2L35.5,42H34l3.4-6.3h1.2L42,42H40.4Zm-2.9-1.3h2.2L38,37.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGiftCard);
export default __webpack_public_path__ + "static/media/logo-gift-card.b0bef76bde25a55124f1804d0417d13e.svg";
export { ForwardRef as ReactComponent };